import BaseService from './baseService';

export default {

  getDocumentosVencidos(numCgcFornecedor) {
    numCgcFornecedor = numCgcFornecedor ? numCgcFornecedor.replace(/[\W_]+/g, '') : null;
    return BaseService.get("documentosFornec/documentosvencidos?numCgcFornecedor=" + numCgcFornecedor);
  },
  getMotivosIndeferimento(codDocumento) {
    return BaseService.get("documentosFornec/listarmotivosrejeicao?codDocumento=" + codDocumento);
  },
  getDocumentosFornecedorSolicitacao(idForneceSolicitacao) {
    return BaseService.get("documentosFornec/listadocumentosfornecedor?idSolicitacao=" + idForneceSolicitacao);
  },

  getSituacaoIntegracaoRegularidadeFiscal(idForneceSolicitacao){
    return BaseService.get("documentosFornec/listarSituacaoIntegracaoRegularidadeFiscal?idSolicitacao=" + idForneceSolicitacao);
  },

  // Método para baixar arquivos
  baixarArquivo(arquivoObj) {
    return BaseService.post("arquivo/file", arquivoObj, {
      responseType: 'blob' // Define o tipo de resposta como blob para arquivos binários
    });
  }

}
